import React from 'react';

import DetailEmpretec from './components/detail-empretec/detail-empretec';

function Detail() {
  // const { getRouteParam, navigateTo } = Sebrae.useRouter();

  return <DetailEmpretec />;
}

export default Detail;
